<template>
    <div>
        <div class="row pl-3 mb-4">
            <button class="btn btn-success pl-3 pr-3" @click="createNewInventario">
                <i class="fas fa-play"></i> {{ $t('Iniciar novo inventário')}}</button>
        </div>
        <table class="table table-striped tabelaInventario">
            <thead>
                <tr>
                    <th scope="col">{{$t('Dt Inicial')}}</th>
                    <th scope="col">{{$t('Dt Final')}}</th>
                    <th scope="col">{{$t('Status')}}</th>
                    <th scope="col">{{$t('Ação')}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(inventario, index) in inventarios" :key="index">
                    <td>{{ inventario.dt_inicio | formatDate('DD/MM/YYYY') }}</td>
                    <td>{{ inventario.dt_final | formatDate('DD/MM/YYYY') }}</td>
                    <th scope="row">{{ $t(inventario.st_etapa) }}</th>
                    <th scope="row"><router-link :to="'inventarioItens/' + inventario.nr_sequencial" class="btn"><i
                                class="fa fa-eye"></i></router-link></th>
                </tr>
            </tbody>

        </table>
    </div>
</template>
<script>

export default {
    components: {
    },

    computed: {
        inventarios() {
            const inventarios = this.$store.getters['inventario/getInventarios']

            if (!inventarios) {
                this.$store.dispatch('inventario/getInventarios')
            }

            return inventarios
        },
    },

    methods: {
        createNewInventario() {
            this.$swal.fire({
                title: this.$t('Iniciar novo inventário'),
                text: this.$t('Deseja iniciar um novo inventário?'),
                icon: 'warning',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                cancelButtonText: this.$t('Não'),
                confirmButtonText: this.$t('Sim')
            }).then((result) => {
                if (result.value == true) {
                    this.$store.dispatch('inventario/createNovoInventario').then(response => {
                        if (response.data.mensagem == 'EmExecucao') {
                            this.$swal.fire({
                                title: 'Oops!',
                                text: this.$t('Já existe um inventário em execução'),
                                icon: 'error'
                            })

                            return false
                        }

                        this.$swal.fire({
                            title: this.$t('Sucesso!'),
                            text: this.$t('Inventário criado com sucesso!'),
                            icon: 'success'
                        })
                    })

                    this.$store.dispatch('inventario/getInventarios')
                }
            })
        },
        getInventarios() {
            this.$store.dispatch('inventario/getInventarios')
        }
    },

    created() {
        this.getInventarios()
    }
}
</script>
<style src="./style.css" lang="css"></style>